import { render, staticRenderFns } from "./ProjectEffort.vue?vue&type=template&id=8c668e4e&scoped=true&"
import script from "./ProjectEffort.vue?vue&type=script&lang=js&"
export * from "./ProjectEffort.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEffort.vue?vue&type=style&index=0&id=8c668e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c668e4e",
  null
  
)

export default component.exports